let cartItemTemplate = `
<div class="sidecart-item" data-id="{id}" data-price="{unit-price}" data-line-quantity="1">
  <div class="sidecart-item__container">
    <div class="sidecart-item__image"><a href="{url}">
        <img width="140" src="{image}" class="sidecart-item__image">
      </a>
    </div>
    <div class="sidecart-item__content">
      <div class="sidecart-item__title mb-16">
        <a class="miller italic normal-text" href="{url}">{title}</a>
      </div>
      <div class="sidecart-item__price miller italic normal-text mb-16">
        {price}
      </div>
      <button data-id="{id}" class="sidecart-item__remove small-text secondary-color">
        Supprimer
      </button>
    </div>
  </div>
</div>
`;

class SideCart extends HTMLElement {
  constructor() {
    super();

    setTimeout(this.initScreenVar, 500);
    this.initEvents();
    window.addEventListener("resize", this.initScreenVar);
    window.addEventListener("cart:updated", this.getCart.bind(this));
  }

  initScreenVar() {
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight / 100}px`
    );
  }

  initEvents() {
    document
      .querySelector('[data-modal="cart"]')
      .addEventListener("click", this.toggleCart.bind(this));
    this.querySelector(".sidecart__close").addEventListener(
      "click",
      this.toggleCart.bind(this)
    );
    // check if click outside of cart
    document.addEventListener("click", (e) => {
      if (
        e.target.closest(".sidecart") === null &&
        e.target.closest('[data-modal="cart"]') === null &&
        e.target.closest("[data-open-popin]") === null
      ) {
        this.classList.remove("open");
        if (
          !document.querySelector(".header--active") &&
          !document.querySelector(".header--hover")
        ) {
          document.querySelector("body").classList.remove("shadow-sidecart");
        }
      }
    });

    document
      .querySelectorAll(".sidecart-gift__content, .sidecart-gift__checkbox")
      .forEach((element) => {
        element.addEventListener("click", () => {
          this.querySelector(".sidecart-gift").classList.toggle(
            "sidecart-gift--enabled"
          );
          let message_element = this.querySelector(".sidecart-gift__textarea");
          message_element.disabled = !message_element.disabled;
        });
      });

    document
      .querySelector(".sidecart-gift__textarea")
      .addEventListener("change", (e) => {
        this.updateCartGiftMessage(e.target.value);
      });
    document
      .querySelector(".sidecart-gift__textarea")
      .addEventListener("input", (e) => {
        this.querySelector(".sidecart-contents__checkout").setAttribute(
          "disabled",
          "disabled"
        );
      });

    this.initRemoveEvents();
  }

  updateCartGiftMessage(message) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          gift_message: message,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setTimeout(
          function () {
            this.querySelector(".sidecart-contents__checkout").removeAttribute(
              "disabled"
            );
          }.bind(this),
          500
        );
      });
  }

  initRemoveEvents() {
    this.querySelectorAll(".sidecart-item__remove").forEach((button) => {
      if (button.dataset.listener === "true") return;
      console.log(button.dataset.listener);
      console.log(button);
      button.addEventListener("click", this.removeProduct.bind(this));
      button.dataset.listener = "true";
    });
  }

  removeProduct(e) {
    let id = e.currentTarget.getAttribute("data-id");

    let total_quantity =
      document.querySelectorAll(`.sidecart-item[data-id="${id}"]`).length - 1;
    e.currentTarget.closest(".sidecart-item").classList.add("removed");

    this.fetchUpdateCart(parseInt(id), total_quantity);
  }

  toggleCart() {
    this.classList.toggle("open");
    if (
      document.querySelector("body").classList.contains("shadow-sidecart") &&
      !document.querySelector("side-cart").classList.contains("open") &&
      (!document.querySelector(".header--active") ||
        !document.querySelector(".header--hover"))
    ) {
      document.querySelector("body").classList.remove("shadow-sidecart");
    } else {
      document.querySelector("body").classList.add("shadow-sidecart");
    }
  }

  openCart() {
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-sidecart");
  }

  addToCart() {
    let items = [
      {
        quantity: 1,
        id: 44567880007982,
      },
      {
        quantity: 1,
        id: 44567879975214,
      },
    ];
    this.fetchAddToCart(items);
  }

  refreshCart(data) {
    console.log(data);
    let is_empty = data.items.length === 0;

    is_empty
      ? this.classList.add("sidecart--empty")
      : this.classList.remove("sidecart--empty");

    for (const item of data.items) {
      let html = "";
      let quantity = document.querySelectorAll(
        `.sidecart-item[data-id="${item.id}"]`
      ).length;
      console.log(item.quantity, quantity);
      if (item.quantity > quantity) {
        for (var i = quantity; i < item.quantity; i++) {
          html = cartItemTemplate
            .replace("{url}", item.url)
            .replace("{image}", item.image)
            .replace("{title}", item.title)
            .replace("{price}", item.price / 100 + " €")
            .replace("{quantity}", item.quantity)
            .replace("{unit-price}", item.price)
            .replaceAll("{id}", item.id);
          this.querySelector(
            ".sidecart-contents__items div:first-child"
          ).insertAdjacentHTML("afterend", html);
        }
      }
    }

    this.initRemoveEvents();

    /** Check all items to remove **/
    let items = this.querySelectorAll(".sidecart-item");

    if (data.token) {
      console.log(items);
      for (const item of items) {
        // let id = item.getAttribute("data-id");
        // let total_quantity = document.querySelectorAll(
        //   `.sidecart-item[data-id="${id}"]`
        // ).length;
        // let found = false;
        // let cart_quantity = 0;
        // let diff = 0;
        // for (const data_item of data.items) {
        //   console.log(data_item.id, id);
        //   if (data_item.id == id) {
        //     found = true;
        //     cart_quantity = data_item.quantity;
        //     diff = total_quantity - cart_quantity;
        //     break;
        //   }
        // }
        // if (!found || diff > 0) {
        //   item.remove();
        // }

        if (item.classList.contains("removed")) {
          item.remove();
        }
      }
    }

    items = this.querySelectorAll(".sidecart-item");
    let nb_items = 0;
    for (const item of items) {
      nb_items += parseInt(item.dataset.lineQuantity);
    }

    let total_price = document.querySelector("[data-cart-total]");
    let price = 0;

    document.querySelector("[data-cart-count]").innerHTML = `${nb_items}`;

    for (const item of items) {
      price += parseFloat(item.dataset.price);
    }
    total_price.innerHTML = "€" + price / 100;
    if (price / 100 >= 500) {
      document
        .querySelector(".sidecart-contents__shippping")
        .classList.remove("hidden");
      document
        .querySelector("[data-freeshipping-sidecart]")
        .classList.remove("hidden");
    } else {
      document
        .querySelector(".sidecart-contents__shippping")
        .classList.add("hidden");
      document
        .querySelector("[data-freeshipping-sidecart]")
        .classList.add("hidden");
    }

    this.openCart();
  }

  fetchAddToCart(items) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.refreshCart(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  fetchUpdateCart(id, quantity) {
    var url = "/cart/update.js";
    const update_label = "updates[" + id + "]=" + quantity;
    const body = update_label;

    fetch(url, {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.refreshCart(data);
      })
      .catch(() => {});
  }

  getCart() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        this.refreshCart(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("side-cart", SideCart);
